<template>
  <v-app>
    <v-container fluid grid-list-lg>
        <v-card>          
          <v-app-bar flat >
            <v-icon>event</v-icon>
            <v-toolbar-title class="font-weight-light">&nbsp;Configuración de Feriados</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn text icon color="red" v-on="on" @click="setStatusTareaFrecuente(action)">
                  <v-icon v-if="action.esFrecuente">favorite</v-icon>
                  <v-icon v-else>favorite_border</v-icon>
                </v-btn>
              </template>
              <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>  
              <span v-else>Agregar a Tareas Frecuentes</span>  
            </v-tooltip>
          </v-app-bar>
          <v-card-text>
            <v-layout  wrap >               
                <v-flex xs12 sm6 md6 lg6>
                  <v-card>
                    <v-app-bar flat dense :color="$store.state.UiColors.crudToolbarList">
                      <v-icon>list</v-icon>
                      <v-toolbar-title class="font-weight-light">Años</v-toolbar-title>
                      <v-spacer></v-spacer>                      
                    </v-app-bar>

                    <v-data-table 
                      :headers="headers"
                      :items="records"
                      :server-items-length="totalItems"
                      v-model="selectedRow"
                      :loading="loading"
                    >
                      <template slot="no-data">
                        <v-alert :value="true" color="grey" icon="warning">
                          No se encontraron datos
                        </v-alert>
                      </template>
                      <template v-slot:item="{ item }">
                        <tr @click="viewItem(item)">
                        <td class="text-xs-left">{{ item.año }}</td>

                        <td class="text-xs-left">                
                          <v-icon small class="mr-2" @click="editItem(item)" v-show="canUpdate">edit</v-icon></td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card >
                </v-flex>
                <v-flex xs12 sm6 md6 lg6>
                  <v-card >
                    <v-app-bar flat dense :color="$store.state.UiColors.crudToolbarDetail">
                      <v-icon>event</v-icon>
                      <v-toolbar-title class="font-weight-light">Feriados Año {{model.fecha.substring(0,4)}}</v-toolbar-title>
                      <v-spacer></v-spacer>

                      <v-btn 
                        :color="$store.state.UiColors.crudToolbarDetailButtons" fab small top @click="editMode = !editMode" v-show="canUpdate">
                        <v-icon v-if="editMode">cancel</v-icon>
                        <v-icon v-else>edit</v-icon>
                      </v-btn>
                    </v-app-bar>
                    <v-card-text>
                      <v-form  :disabled="!editMode">
                          <v-layout wrap>
                            <v-flex
                              xs12
                              class="mb-3"
                            >
                              <v-sheet height="500">
                                <v-calendar
                                  ref="calendar"
                                  v-model="model.fecha"
                                  :value="model.fecha"
                                  :type="type"
                                  :disabled="!editMode"
                                >
                                <template v-slot:day="{ date }">
                                  <template v-for="feriado in feriadosMap[date]">
                                    <v-menu
                                      :key="feriado.motivo"
                                      v-model="feriado.open"
                                      full-width
                                      offset-x
                                    >
                                      <template v-slot:activator="{ on }">
                                        <div
                                          v-if="!feriado.time"
                                          v-ripple
                                          class="my-feriado"
                                          v-on="on"
                                          v-html="feriado.motivo"
                                        ></div>
                                      </template>
                                      <v-card
                                        color="grey lighten-4"
                                        min-width="350px"
                                        text
                                      >
                                        <v-toolbar
                                          color="primary"
                                          dark
                                        >
                                          <v-btn icon>
                                            <v-icon>edit</v-icon>
                                          </v-btn>
                                          <v-toolbar-title v-html="feriado.motivo"></v-toolbar-title>
                                          <v-spacer></v-spacer>
                                        </v-toolbar>
                                        <v-card-actions>
                                          <v-btn
                                            text
                                            color="secondary"
                                            @click="remove(feriado)"
                                            :disabled="!editMode"
                                          >
                                            Quitar
                                          </v-btn>
                                          <v-spacer></v-spacer>
                                          <v-btn
                                            text
                                            color="secondary"
                                          >
                                            Cancelar
                                          </v-btn>
                                        </v-card-actions>
                                      </v-card>
                                    </v-menu>
                                  </template>
                                </template>
                              </v-calendar>
                              </v-sheet>
                            </v-flex>

                            <v-flex
                              sm4
                              xs12
                              class="text-sm-left text-xs-center"
                            >
                              <v-btn rounded @click="$refs.calendar.prev();" color="orange" :disabled="mesAnteriorDisabled">
                                <v-icon
                                  dark
                                  left
                                >
                                  keyboard_arrow_left
                                </v-icon>
                                Anterior
                              </v-btn>
                            </v-flex>
                            <v-spacer></v-spacer>
                            <v-flex
                              sm4
                              xs12
                              class="text-sm-right text-xs-center"
                            >
                              <v-btn rounded @click="$refs.calendar.next()" color="orange" :disabled="mesSiguienteDisabled">
                                Siguiente
                                <v-icon
                                  right
                                  dark
                                >
                                  keyboard_arrow_right
                                </v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-form>
                        
                        <v-layout>
                          <v-flex xs6>
                              <v-text-field v-model="model.fecha" label="Fecha" type="date" prepend-icon="event" 
                                  @input="fechaChanged" :disabled="!editMode"></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field v-model="motivoNuevoFeriado" label="Motivo" :disabled="!editMode"></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout>
                          <v-flex xs6>
                            <v-btn rounded @click="agregarFeriadoPuntual" :disabled="!editMode" color="orange">
                                Agregar Feriado Puntual
                              </v-btn>
                          </v-flex>
                          <v-flex xs6>
                            <v-btn rounded @click="cargarFeriados(model.fecha.substring(0,4))" :disabled="!editMode" color="orange">
                                <v-icon>search</v-icon> Buscar Feriados del Año</v-btn>
                          </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions bottom>
                            <v-spacer></v-spacer> 
                            <v-btn color="success"  @click="saveItem" :disabled="!editMode"><v-icon>save</v-icon>Guardar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-flex>
              
            </v-layout>
          </v-card-text>
        </v-card >
    </v-container>
</v-app>
</template>

<style lang="stylus" scoped>
  .my-feriado {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;
    background-color: #1867c0;
    color: #ffffff;
    border: 1px solid #1867c0;
    width: 100%;
    font-size: 12px;
    padding: 3px;
    cursor: pointer;
    margin-bottom: 1px;
  }
</style>

<script>

import { http } from '@/axios'
import Vue from 'vue'
import {
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
  data() {
    return {
      loading: false,
      editMode: false,
      suspend: false,
      totalItems: 0, // va afuera de options
      headers: [ // definición de columnas
        { text: 'Año', value: 'año' },
        { text: 'Acciones', value: 'name', sortable: false }
      ],        
      records: [], // registros
      selectedRow: [],
      model: {fecha: '', feriados:[]}, // registro para ver/editar
      type: 'month',
      start: '',
      motivoNuevoFeriado: ''
    };
  },
  async created() {     
    this.getItems();
  },
  watch: {
  },
  computed: {
    ...mapGetters(['checkCanCreate', 'checkCanUpdate', 'checkCanDelete','getActionFromLink']),
    canCreate: function(){
      return this.checkCanCreate(this.$route.path)
    },
    canUpdate: function(){
      return this.checkCanUpdate(this.$route.path)
    },
    canDelete: function(){
      return this.checkCanDelete(this.$route.path)
    },
    action: function(){
      return this.getActionFromLink(this.$route.path)
    },
    // convert the list of events into a map of lists keyed by date
    feriadosMap () {
      const map = {}
      this.model.feriados.forEach(e => (map[e.fecha] = map[e.fecha] || []).push(e))
      Vue.$log.debug(map);
      return map
    },
    mesAnteriorDisabled: function(){
      //Ese substring es el número de mes. Si es <= 1 está deshabilitado
      return (parseInt(this.model.fecha.substring(5,7))>1) ? false : true;
    },
    mesSiguienteDisabled: function(){
      //Ese substring es el número de mes. Si es >= 12 está deshabilitado
      return (parseInt(this.model.fecha.substring(5,7))<12) ? false : true;
    },
  },
  methods: {
    ...mapMutations(["alertClear", "alertSuccess", "alertWarning", "alertError"]),
    ...mapActions(['setStatusTareaFrecuente']),
    fechaChanged(newDate){
      Vue.$log.debug(newDate);
      this.model.fecha = newDate
    },
    async getItems() {
      var fechaActual = new Date();//1 de enero del año
      var añoActual = fechaActual.getFullYear();

      for(var i = añoActual - 1; i < añoActual + 4 ; i++)
      {
        this.records.push({año:i})
      }
      
      this.totalItems = 5;
    },
    async resetState(){      
      this.$validator.reset()
      this.editMode = false;
    },
    async getItem(año) {
      this.loading = true
      this.resetState()

      var fecha = new Date(año,0);//1 de enero del año
      this.setFecha(fecha);

      Vue.$log.debug(fecha);
      
      try {
        var result = await http.get('feriados?año='+año );
        Vue.$log.debug(result);
        if(result.count > 0)
        {
          this.setFeriados(result.list);
        }

        Vue.$log.debug(this.model);
      } catch (error) {
        // Error        
        this.alertError(error)
      }
      
      this.loading = false
    },    
    async viewItem(item){
      Vue.$log.debug(item);
      if(this.suspend) return;

      this.selectedRow.pop()
      this.selectedRow.push(item)

      await this.getItem(item.año);
      this.editMode = false;      
    },
    async clearAndReload(){
        // Clear the data inside of the form
        this.model = {fecha: '', feriados:[]}
        this.resetState()

        // Refresco la grilla
        //await this.getItems()
    },
    async editItem(item){
      this.suspend = true; // hago esto porque se dispara también el evento click del row (que llama a viewItem)
      
      if(!item)
        await this.getItem(0);
      else
        await this.getItem(item.año);
      
      this.editMode = true;
      this.suspend = false;
    },
    async cancelEdit() {
      this.editMode = false;
    },
    async saveItem() {
      await this.$validator.validateAll()
      
      if(this.errors.items.length > 0) return;

      this.model.año = this.model.fecha.substring(0,4);

      Vue.$log.debug(this.model)
      try{
        await http.put('feriados/updateferiadosbyaño', JSON.stringify( {feriados:  this.model} ) );
        this.alertSuccess('Los cambios han sido guardados.')
        this.clearAndReload();

      } 
      catch(error){
        // Error
        this.alertError(error)
      }        
    },
    async cargarFeriados(año) {
      this.loading = true

      try {
        var result = await http.get('http://nolaborables.com.ar/api/v2/feriados/' + año);   

        this.model.feriados = [];
        for(var i = 0;i<result.length;i++)
        {
          var dia = result[i].dia;
          var mes = result[i].mes;
          if(dia < 10)
            dia = '0' + dia;
          if(mes < 10)
            mes = '0' + mes;
          var fecha = año + '-' + mes + '-'+ dia;
          this.model.feriados.push({motivo:result[i].motivo,fecha:fecha,open:false})
        }

        this.alertSuccess('Se cargaron los feriados del año ' + año);
      } catch (error) {
        // Error
        this.alertError('Se produjo un error buscando los feriados.')
      }
      this.loading = false
    },
    setFeriados(feriados){
        this.model.feriados = [];
        for(var i = 0;i<feriados.length;i++)
        {
          var fecha = feriados[i].fecha.substring(0,10)
          this.model.feriados.push({motivo:feriados[i].motivo,fecha:fecha,open:false})
        }
    },
    setFecha(fecha){
        var dd = String(fecha.getDate()).padStart(2, '0');
        var mm = String(fecha.getMonth() + 1).padStart(2, '0'); //Enero es 0
        var yyyy = fecha.getFullYear();

        this.model.fecha = yyyy + '-' + mm + '-' + dd;
        this.fecha = yyyy + '-' + mm + '-' + dd;
        this.start = '01/01/' + yyyy;
    },
    agregarFeriadoPuntual(){
      if(!this.motivoNuevoFeriado)
      {
        this.alertWarning('Debe ingresar un motivo de feriado a cargar.');
        return;
      }
      
      var estaEnLista = false;  

      for (let i = 0; i < this.model.feriados.length; i++) {
        if(this.model.feriados[i].fecha === this.model.fecha)
        {
          estaEnLista = true;
        }
      }

      if(!estaEnLista){
        this.model.feriados.push({motivo:this.motivoNuevoFeriado,fecha:this.model.fecha,open:false})
      }
      else
        this.alertWarning('La fecha de feriado ya está cargada.');
    },
    remove(feriado){
      if (confirm('¿Desea quitar el feriado ' + feriado.motivo + ' de la lista?')) {
        var i = 0;
        for (i = 0; i < this.model.feriados.length; i++) { 
          if(this.model.feriados[i] == feriado){
              break;
          }
        }
        this.model.feriados.splice(i,1);
      }
    }
  }
}
</script>

